module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABQElEQVQ4T6WTvUoDURCFv9llkbSClRaCb2BnFW0FxV6IECG7VuIPovYiiKYL7G4hmBewEKwsfBFR0C5glSYWe+QGDfndLDrlcObjzNxzjX+Wufk0TauSzoAloNvLKQEvZnZZq9VuLUmSGpD80UjoAK/AYj/AzDYk7QJbU8BvDpAN2w7D0NI0LbthSXVgeQJIDuB2GigHcH0zuwdOJa0AF8D8sDYX8CP+AhqdTqceBMGe53nnA+vmOegTPgAHwCbgVurVNAevkvZ9329lWdYYd4tcQJZla57nbQNVwBt3SAd4BxaGnnFV0nOBbHxYHMeHZnZTQDwikXTUjW0cx8dmdgLMFQS1JF1FUXTdy70kazabs+12O/iF+L5fNrM7YAboSNoplUpPlUrl08y6+Zn2cZy7dQdxw1EUPY4EqaDlibJvqnSLj6OCm1QAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/assets/img/sider/sider5-1.png
// module id = 972
// module chunks = 2